import React, { useContext } from "react";
// Router
import { Link } from "react-router-dom";
// Contexto
import { ConfirmModalContext } from "../../context/confirmModalContext";
import { cargosContext } from "../../contexto";
import { ModalContext } from "../../context/modalContext";
// Componentes
import ComponentTable from "../generic/ComponentsTable";
import Icon from "../generic/Icon";
import FormCargo from "./FormCargo";
import TooltipIcon from "../generic/TooltipIcon";
// Images
import deleteIcon from "../../assets/delete.png";
import editIcon from "../../assets/editing.png";
// Utils
import { dateToString } from "../../utils";

import { Image } from "react-bootstrap";

const TablaCargos = ({ type, cargos, esCargoActual, handlePutCargo, handleDeleteCargo, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

  // Obtiene el usuario en la tabla con la función de redirección
  const getUsuario = (row) => {
    let tipo = row?.user?.type === "Monja" ? "hermanas" : "laicos";
    return <Link to={`/${tipo}/${row?.userId}`}>{`${row?.user?.name} ${row?.user?.firstSurname} ${row?.user?.secondSurname}`}</Link>;
  };

  // Devuelve el cargo en función del tipo de entidad
  const getCargo = (row) => {
    return cargosContext[type]["cargos"][row.cargo];
  };

  // Procesa la fecha startdate y la devuelve
  const processStartDate = (row) => {
    if (row.startDate) return dateToString(row.startDate);
    else return "";
  };

  // Procesa la fecha de endDate y la devuelve
  const processEndDate = (row) => {
    if (row.endDate) return dateToString(row.endDate);
    else return "No especificado";
  };

  // Gestiona la acción que se realiza cuando damos en la imagen de editar cargo
  const editCargo = (row) => {
    if (esCargoActual(row)) {
      return (
        <Icon
          src={editIcon}
          onClick={() => {
            modalSetShow(true, "80%");
            modalSetTitle(`Editar ${cargosContext[type]["cargoServicio"].toLowerCase()}.`);
            modalSetContent(<FormCargo submissionHandler={handlePutCargo} defaultValues={row} type={type} {...props} />);
          }}
          className="d-flex m-auto"
        />
      );
    }
    return <TooltipIcon className="text-center" content={`Este ${cargosContext[type]["cargoServicio"].toLowerCase()} no es actual por lo que no se puede editar`} />;
  };

  // Gestiona la acción que se realiza cuando damos en la imagen de eliminar cargo
  const deleteCargo = (row) => {
    return (
      <Icon
        src={deleteIcon}
        onClick={() => {
          
            confirmModalSetTitle(`Eliminar ${cargosContext[type]["cargoServicio"].toLowerCase()}`);
            confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el ${cargosContext[type]["cargoServicio"].toLowerCase()}?`} </p>);
            confirmModalSetFunction(() => {
              handleDeleteCargo(row);
            });
            confirmModalSetShow(true);
          
        }}
        className="d-flex m-auto"
      />
    );
  };

  const getImagen = (row) => {

    {console.log(row)}
    return <Image
      style={{ objectFit: "contain", maxHeight: "60px" }}
      className="img-fluid-detalle"
      variant="top"
    
      src={
        row.user.photo ?
          `${process.env.REACT_APP_API_URL}/download/usuarios/${row.userId}` 
          : 
            row.user.type === 'Monja' ? `/images/nun.png` 
            :
            row.user.gender === 'h' ? `/images/laico1.png` 
              :
              `/images/laico2.png`
      }    
      alt="sisterImg"
    />
  }

  return (
    <ComponentTable
      emptyTableComponent={
        <p className="m-2">{cargosContext[type]["cargos"] !== "rl" ? `No se han encontrado ${cargosContext[type]["cargoServicio"].toLowerCase()}s` : `No se han encontrado representantes legales`}</p>
      }
      headers={[
        { name: "Foto", value: getImagen },
        { name: cargosContext[type]["usuario"], value: getUsuario },
        // Sino es representante legal mostramos los cargos
        cargosContext[type]["cargos"] !== "rl" && { name: cargosContext[type]["cargoServicio"], value: getCargo },
        { name: "Fecha inicio", value: processStartDate },
        { name: "Fecha de fin", value: processEndDate },
        { name: "Editar", value: editCargo, style: { width: 15 } },
        { name: "Eliminar", value: deleteCargo, style: { width: 15 } },
      ]}
      rows={cargos}
    />
  );
};

export default TablaCargos;
